import PageHero from '../components/sections/PageHero';
import ServicesGrid from '../components/sections/ServicesGrid';
import ComplianceStrip from '../components/sections/ComplianceStrip';
import CtaBanner from '../components/sections/CtaBanner';

export default function Services() {
  return (
    <>
      <PageHero
        eyebrow="Services"
        title="Everything between your loading bay and a closed EPR obligation"
        description="Eight services that cover collection, secure destruction, value recovery and the statutory filings that follow. Engage them individually or as a managed programme."
      />

      <ServicesGrid detailed />
      <ComplianceStrip />
      <CtaBanner />
    </>
  );
}
